// Product popup: when URL contains ?code=CODE, fetch remote product image and show modal
(function(){
  'use strict';

  function getQueryCode() {
    try {
      var params = new URLSearchParams(window.location.search);
      var c = params.get('code');
      return c ? String(c) : null;
    } catch (e) { return null; }
  }

  function insertStyles() {
    if (document.getElementById('product-popup-styles')) return;
    var s = document.createElement('style');
    s.id = 'product-popup-styles';
    s.textContent = `
    .pp-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.6);z-index:99999;padding:12px}
    .pp-card{background:transparent;border-radius:10px;max-width:1100px;width:100%;box-shadow:none;display:flex;flex-direction:column;align-items:center;overflow:hidden}
    .pp-media{width:100%;display:flex;align-items:center;justify-content:center;background:transparent;padding:0}
    .pp-media img{width:100%;height:auto;max-height:85vh;object-fit:contain;border-radius:8px;background:#fff;padding:12px}
    .pp-meta{width:100%;padding:12px 20px 18px 20px;display:flex;justify-content:center;gap:12px;flex-direction:column;align-items:center}
    .pp-desc{color:#333;text-align:center;font-size:15px}
    .pp-actions{display:flex;gap:10px;align-items:center;justify-content:center}
    .pp-download{background:#0a84ff;color:#fff;padding:10px 16px;border-radius:8px;text-decoration:none;font-weight:600;cursor:pointer;border:0}
    .pp-close{position:fixed;top:18px;right:18px;background:rgba(0,0,0,.5);border:0;color:#fff;font-size:20px;padding:6px 10px;border-radius:6px;cursor:pointer}
    @media (max-width:720px){.pp-media img{max-height:70vh;padding:8px}}`;
    document.head.appendChild(s);
  }

  function createModal() {
    insertStyles();
    var modal = document.createElement('div');
    modal.className = 'pp-modal';
    modal.innerHTML = `
      <div class="pp-card" role="dialog" aria-modal="true">
        <div class="pp-media">
          <div id="pp-loading" style="color:#666;text-align:center">Loading image…</div>
          <img id="pp-image" style="display:none" alt="Product image">
        </div>
        <div class="pp-meta">
          <div id="pp-desc" class="pp-desc" aria-hidden="false"></div>
          <div class="pp-actions">
            <button id="pp-download" class="pp-download">Download</button>
          </div>
        </div>
        <button id="pp-close" class="pp-close" aria-label="Close">✕</button>
      </div>
    `;
    modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(modal); });
    return modal;
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.remove();
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('code');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function showError(modal, msg) {
    var holder = modal.querySelector('.pp-media');
    holder.innerHTML = '<div style="color:#b00020;text-align:center;padding:20px">'+String(msg)+'</div>';
  }

  function fetchAndShow(code, modal) {
    var imgEl = modal.querySelector('#pp-image');
    var loading = modal.querySelector('#pp-loading');
    var descEl = modal.querySelector('#pp-desc');
    var downloadBtn = modal.querySelector('#pp-download');

    if (loading) loading.style.display = 'block';

    // Use endpoint as image source
    var endpoint = 'https://loretana-backend.vercel.app/generate/original/' + encodeURIComponent(code);

    // Add cache buster
    var cacheBusted = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();
    imgEl.src = cacheBusted;
    imgEl.alt = 'Product image';

    imgEl.onload = function() {
      imgEl.style.display = 'block';
      if (loading) loading.style.display = 'none';
    };

    imgEl.onerror = function() {
      showError(modal, 'Failed to load image. Please try again.');
    };

    // Optional description
    if (descEl) descEl.textContent = 'Your QR Code';

    // --- DIRECT DOWNLOAD BUTTON (No Redirect) ---
    if (downloadBtn) {
      downloadBtn.onclick = async function () {
        try {
          const response = await fetch(imgEl.src, { mode: 'cors' });
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'qr-code.png';
          document.body.appendChild(a);
          a.click();
          a.remove();

          URL.revokeObjectURL(url);
        } catch (e) {
          alert('Failed to download image.');
        }
      };
    }
  }

  function initPopup() {
    var code = getQueryCode();
    if (!code) return;

    var modal = createModal();
    var closeBtn = modal.querySelector('#pp-close');
    closeBtn.addEventListener('click', function(){ closeModal(modal); });
    document.body.appendChild(modal);

    function onKey(e){ if (e.key === 'Escape') { closeModal(modal); document.removeEventListener('keydown', onKey); } }
    document.addEventListener('keydown', onKey);

    fetchAndShow(code, modal);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initPopup();
  } else {
    document.addEventListener('DOMContentLoaded', initPopup);
  }

})();
